import { RRIInputOption } from '../../form-inputs/interfaces/input-option.interface';
import { RRAvatarGeneratorMeassurementsModel } from './avatar-generator-meassurements.model';

export class RRAvatarGeneratorFieldsModel {
  name: string;
  gender: RRIInputOption<string>;
  poseId: RRIInputOption<string>;
  bodyType: RRIInputOption<string>;
  meassurments: RRAvatarGeneratorMeassurementsModel[];
}
